import {useTheme} from "@mui/material";
import {Bar, BarChart, CartesianGrid, Cell, Tooltip, XAxis, YAxis} from "recharts";
import Message from "../../../pages/components/message";
import {MessageSections} from "../../../pages/components/message/message";
import {BarContainer, TotalCardTitle} from "../styled";
import NoOrders from "../../../pages/orders/my/no-orders";
import {useAppSelector} from "../../../redux/store";
import React from "react";
import {DashboardTooltip} from "./tooltip";

const BarekamGroupedBar = ({data, title, filters}: BarekamGroupedBarProps) => {
    const {orderStates} = useAppSelector(state => state.staticDataReducer);
    const regexp = /hsl\(\s*(\d+)\s*,\s*(\d+(?:\.\d+)?%)\s*,\s*(\d+(?:\.\d+)?%)\)/g;

    const theme = useTheme();

    function getColor(index: number, orderStateId: number) {
        const color = theme.barekam.dashboard.barColors[index];

        if (color) {
            const res = regexp.exec(color);

            if (res) {
                const hue = res[3];
                const modifiedHue = +(hue.replace('%', '')) + (orderStateId * 3);

                return color.replace(hue, modifiedHue + '%');
            }

            return color;
        } else {
            return '#000'
        }
    }

    return (
        <BarContainer style={{minHeight: '33rem'}}>
            <TotalCardTitle>
                <Message messageKey={title} sectionId={MessageSections.ORDERS}/>
            </TotalCardTitle>

            {filters || ''}

            {data.length
                ? <BarChart
                    width={500}
                    height={340}
                    data={data}
                    barGap={0}
                    stackOffset="sign"
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}>
                    <CartesianGrid vertical={false}/>
                    <Tooltip content={DashboardTooltip}/>
                    <XAxis dataKey="name" axisLine={false}/>
                    <YAxis  axisLine={false}/>

                    {orderStates.map(state => {
                        return (<>
                            <Bar dataKey={state.name} isAnimationActive={false}>
                                {data.map(({value, name}, index) => (
                                    <Cell key={`cell-${name}`}
                                          fill={getColor(index, state.orderStateId)}
                                    />
                                ))}
                            </Bar>
                        </>)
                    })}
                </BarChart>
                : <NoOrders messageKey={'no_total_orders'}/>
            }
        </BarContainer>
    );
};

interface BarekamGroupedBarProps {
    data: any[],
    title: string,
    filters?: React.ReactElement,
}

export default BarekamGroupedBar;
